// src/services/oneBitCustomService.js
import { db } from '../firebase';
import { collection, getDocs, serverTimestamp, writeBatch, doc } from 'firebase/firestore';
import { decodeOneBit, packBits } from '../utils/oneBit';

const COLLECTION = 'nono-onebit-custom';

const hashOf = (text) => {
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) h = Math.imul(h ^ text.charCodeAt(i), 16777619);
  return (h >>> 0).toString(16);
};

// Icons cut from sprite sheets in the editor, shown in the 1-bit picker next to the bundled library.
export const fetchCustomOneBitIcons = async () => {
  const snapshot = await getDocs(collection(db, COLLECTION));
  return snapshot.docs.map(d => {
    const { w, h, data, name } = d.data();
    return decodeOneBit([w, h, data, name, 'custom']);
  });
};

// Bitmaps are { w, h, bits }. The doc id comes from the pixels, so adding the same sprite twice keeps one copy.
export const addCustomOneBitIcons = async (bitmaps, name = '') => {
  for (let i = 0; i < bitmaps.length; i += 400) {
    const batch = writeBatch(db);
    bitmaps.slice(i, i + 400).forEach((b, k) => {
      const data = packBits(b.bits);
      batch.set(doc(db, COLLECTION, hashOf(`${b.w}x${b.h}:${data}`)), {
        w: b.w, h: b.h, data, name: name ? `${name} ${i + k + 1}` : '', createdAt: serverTimestamp(),
      });
    });
    await batch.commit();
  }
};
